module.exports = __webpack_public_path__ + "static/media/29.799b6ad5.jpg";